<template>
  <div v-if="toggleModal" class="modal_alertas" title="clique para fechar" @click="modalToggle">
    <img
      @click="modalToggle"
      src="https://testweb-serrano.s3.sa-east-1.amazonaws.com/public/banner/GOLPE+CAIXA+-+SITE+JOYCE+RS.png">
    <button
      @click="modalToggle"
      class="tw-bg-jrGray-300 tw-text-white tw-mt-2 tw-px-4 tw-py-1 tw-rounded-md hover:tw-bg-jrRed-50">
      Fechar
    </button>
  </div>
</template>

<script>
export default {
  name:'ModalAlertas',
  data() {
    return {
      toggleModal: true
    }
  },
  methods: {
    modalToggle() {
      this.toggleModal = !this.toggleModal
    }
  }
}
</script>


<style scoped>
.modal_alertas {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(11, 11, 11, 0.12);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.modal_alertas img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalAlertas.vue